import React, {useState, useEffect} from 'react'
import axiosInstance from '../../utils/api';
import './styles/scan-qr.css';
import { Html5QrcodeScanner, Html5QrcodeSupportedFormats } from "html5-qrcode";

export default function ScanQr() {
    const [loading, setLoading] = useState(false)
    let html5QrcodeScanner;
    
    useEffect(() => {
        html5QrcodeScanner = new Html5QrcodeScanner("html5qr-code-full-region", {
            fps: 10,
            qrbox: 250,
            disableFlip: false,
            formatsToSupport: [ Html5QrcodeSupportedFormats.QR_CODE ]
        });
        html5QrcodeScanner.render(
            onNewScanResult, 
        );
    }, [])
    
    function onNewScanResult(decodedText, decodedResult) {
        console.log("App [result]", decodedText);
        let pattern = "farm.matang.app"
        if (decodedText.match(pattern)) {
            setLoading(true)
            html5QrcodeScanner.clear();
            let get_tree_id = decodedText.split("/")[4]
            axiosInstance.get(`${process.env.REACT_APP_API}/trees/show/${get_tree_id}`).then(res=>{
                setLoading(false)
                return window.location.href = `/operations/tree/${get_tree_id}/activity/`
            }).catch(res => {
                setLoading(false)
                alert('Invalid QR')
            })
        }
    }

    return (
        <div className="content-wrapper">

            <div className="overlay-wrapper" style={{ display: (loading?'':'none') }}>
                <div className="overlay"><i className="fas fa-3x fa-sync-alt fa-spin"></i><div className="text-bold pt-2"></div></div>
            </div>

            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Scan QR</h1>
                    </div>
                    <div className="col-sm-6">
                        {/* <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                        <li className="breadcrumb-item"><a href={`/operations/scan-qr`}>Scan QR</a></li>
                        <li className="breadcrumb-item"><a href={`/operations/tree/${treeId}/activity`}>Activity</a></li>
                        <li className="breadcrumb-item active">Inspection</li>
                        </ol> */}
                    </div>
                    </div>
                </div>
            </div>

            <section className="content">

                <div className="container-fluid">

                    

                    <div className="row">
                        <div className="col-12">
                            <div className="text-center p-3">

                                <div className="row justify-content-center">
                                    <div id="html5qr-code-full-region" style={{width:'100%', height: '100%'}}/>
                                </div>


                                {/* <div className="row my-2 px-4">
                                <a className="btn btn-primary w-100" href={`/operations/tree/0131a2912a3443b3a3f5ec17e7f95a51/activity`}>Scan QR</a>
                                </div> */}
                                
                                <div className="row my-2 px-4">
                                    <a className="btn btn-warning w-100" href={`/operations`}>
                                    Back
                                    </a>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                
                
                
                </div>
            </section>


            
        </div>
    )
}
